import React from 'react';
import { createBrowserRouter, Navigate, RouterProvider } from 'react-router-dom';
import HomePage from './Pages/HomePage';
import GamePage from './Pages/GamesPage';

const App = () => {
  const router=createBrowserRouter([
    {
      path:"/",
      element:<HomePage />
    },
    {
      path:"/games",
      element:<GamePage />
    },
    {
      path:"*",
      element:<Navigate to="/" />
    }
  ])
  return (
    <RouterProvider router={router} />
  )
}

export default App